import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const TimelineData = [
  {
    id: "1",
    date: "Consultation & Discovery",
    title: "Understanding Your Vision",
    description: `We begin with a comprehensive consultation to understand your 
                  unique needs and goals. This ensures that our solutions are 
                  perfectly aligned with your business objectives.`,
    image: "vision.svg",
  },
  {
    id: "2",
    date: "Customized Planning",
    title: "Strategizing for Success",
    description: `Our team develops a tailored plan, outlining the best 
                  strategies and technologies to meet your requirements. We 
                  ensure a clear roadmap for the project's success.`,
    image: "plan.svg",
  },
  {
    id: "3",
    date: "Development & Implementation",
    title: "Bringing Ideas to Life",
    description: `We design and develop your custom solution, maintaining close
                  collaboration and transparent communication throughout the 
                  process to ensure everything meets your expectations.`,
    image: "thought.svg",
  },
  {
    id: "4",
    date: "Launch & Support",
    title: "Achieving Excellence",
    description: `After rigorous testing, we launch your solution and provide
                  ongoing support to ensure optimal performance and continuous 
                  improvement.`,
    image: "design.svg",
  },
];

const TimelineOne = () => {
  return (
    <div className="rn-timeline-wrapper timeline-style-one position-relative">
      <div className="timeline-line"></div>
      {/* Start Single Timeline  */}

      {TimelineData.map((data, index) => (
        <div className="single-timeline mt--50" key={index}>
          <div className="timeline-dot">
            <div className="time-line-circle"></div>
          </div>
          <div className="single-content">
            <div className="inner">
              <div className="row row--30 align-items-center">
                <div className="order-2 order-lg-1 col-lg-6 mt_md--40 mt_sm--40">
                  <div className="content">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeInOut"
                      animateOnce={true}
                    >
                      <span className="date-of-timeline">{data.date}</span>
                    </ScrollAnimation>

                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeInOut"
                      animateOnce={true}
                    >
                      <h2 className="title">{data.title}</h2>
                    </ScrollAnimation>

                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeInOut"
                      animateOnce={true}
                    >
                      <p className="description">{data.description}</p>
                    </ScrollAnimation>

                    {/* <div className="row row--30">
                      {data.workingStep.map((data, index) => (
                        <div className="col-lg-6 col-md-6 col-12" key={index}>
                          <div className="working-list">
                            <ScrollAnimation
                              animateIn="fadeInUp"
                              animateOut="fadeInOut"
                              animateOnce={true}
                            >
                              <h5 className="working-title">
                                {data.stepTitle}
                              </h5>
                            </ScrollAnimation>

                            <ScrollAnimation
                              animateIn="fadeInUp"
                              animateOut="fadeInOut"
                              animateOnce={true}
                            >
                              <p>{data.stepDescription}</p>
                            </ScrollAnimation>
                          </div>
                        </div>
                      ))}
                    </div> */}
                    {/* <div className="read-morebtn">
                      <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}
                      >
                        <a
                          className="btn-default btn-large round"
                          href="/contact"
                        >
                          <span>Get Started Now</span>
                        </a>
                      </ScrollAnimation>
                    </div> */}
                  </div>
                </div>
                <div className="order-1 order-lg-2 col-lg-6">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src={`./images/timeline/${data.image}`}
                      alt="Timeline Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* End Single Timeline  */}
    </div>
  );
};

export default TimelineOne;
